{
    "name": "Oliebollen Boerhaar",
    "fullName": "Carnavalsvereniging De Wet'ringdempers",
    "description": "Bestel nu de lekkerste afsluiter van het jaar, Bakker Jolinks oliebollen bezorgd vanuit Boerhaar!",
    "slogan": "Bestel nu de lekkerste afsluiter van het jaar, Bakker Jolinks oliebollen bezorgd vanuit Boerhaar!",
    "kvk_number": "40651120",
    "email": {
        "text": "oliebollen@wetringdempers.nl",
        "href": "oliebollen@wetringdempers.nl"
    }
}
